/* ART IST — mağaza etkileşim motoru (hafif, vanilla, N-seçenekli)
   window.PRODUCT ile çalışır:
   { demo, title, options:[{name,kind:'swatch'|'pill',values:[{v,hex?,img?}]}],
     variants:[{id,opts:{OptName:value},price,available,img}], media:[url], rating:{value,count} } */
(function () {
  'use strict';
  // Sepet sayacı — tüm mağaza sayfalarında
  (function () { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { var el = document.getElementById('cartCount'); if (el) { el.textContent = c.item_count; el.style.display = c.item_count ? 'inline-flex' : 'none'; } }).catch(function () {}); })();

  // Mobil nav: hamburger menü + ürün arama — TÜM mağaza sayfalarında.
  // Başlık markup'ı üç ayrı liquid'de tekrar ettiği için düğmeleri buradan enjekte
  // ediyoruz; böylece tek yerden yönetiliyor.
  (function () {
    var snav = document.querySelector('.snav');
    var bar = snav && snav.querySelector('.snav__bar');
    var links = snav && snav.querySelector('.snav__links');
    if (!bar || !links) return;

    // Menü linkleri + arama + hamburger tek sağ grupta toplanır (space-between bozulmasın).
    // .snav__right'a position VERİLMEZ: mobil menü (.snav.is-open .snav__links) absolute
    // konumunu .snav'a göre alır, taşıma onu bozmaz.
    var right = document.createElement('div');
    right.className = 'snav__right';
    bar.appendChild(right);
    right.appendChild(links);

    // ── Arama düğmesi
    var araBtn = document.createElement('button');
    araBtn.className = 'snav__ara';
    araBtn.type = 'button';
    araBtn.setAttribute('aria-label', ((window.ARTIST_I18N&&window.ARTIST_I18N.urun_ara)||"Ürün ara"));
    araBtn.setAttribute('aria-expanded', 'false');
    araBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="10.5" cy="10.5" r="6.75"/><line x1="15.6" y1="15.6" x2="21" y2="21"/></svg>';
    right.appendChild(araBtn);

    // ── Hamburger (arama düğmesinin sağında)
    var burger = document.createElement('button');
    burger.className = 'snav__burger';
    burger.type = 'button';
    burger.setAttribute('aria-label', ((window.ARTIST_I18N&&window.ARTIST_I18N.menu)||"Menü"));
    burger.setAttribute('aria-expanded', 'false');
    burger.innerHTML = '<span></span><span></span><span></span>';
    right.appendChild(burger);
    burger.addEventListener('click', function () {
      var open = snav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    links.addEventListener('click', function (e) { if (e.target.closest('a')) snav.classList.remove('is-open'); });

    // ── Arama katmanı: .snav'ın backdrop-filter'ı içindeki position:fixed öğeleri
    // kendine göre konumlandırır → katman BODY'ye eklenmeli, snav'ın içine değil.
    var kat = document.createElement('div');
    kat.className = 'ara';
    kat.id = 'ara';
    kat.hidden = true;
    kat.setAttribute('role', 'dialog');
    kat.setAttribute('aria-modal', 'true');
    kat.setAttribute('aria-label', ((window.ARTIST_I18N&&window.ARTIST_I18N.arama)||"Ürün arama"));
    kat.innerHTML =
      '<button class="ara__kapat" type="button" aria-label="Aramayı kapat">Kapat ×</button>' +
      '<div class="ara__ic">' +
        '<label class="ara__label" for="ara-girdi">' + ((window.ARTIST_I18N&&window.ARTIST_I18N.ne_ariyorsunuz)||"Ne arıyorsunuz?") + '</label>' +
        '<input class="ara__girdi" id="ara-girdi" type="search" autocomplete="off" spellcheck="false" ' +
               'placeholder="metalik boya, vernik, fırça…" aria-describedby="ara-ipucu">' +
        '<p class="ara__ipucu" id="ara-ipucu">' + ((window.ARTIST_I18N&&window.ARTIST_I18N.kisayol)||"Enter — tüm sonuçlar · Esc — kapat") + '</p>' +
        '<div class="ara__sonuc" aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(kat);
    araBtn.setAttribute('aria-controls', 'ara');

    var girdi = kat.querySelector('.ara__girdi');
    var sonuc = kat.querySelector('.ara__sonuc');
    var acik = false, sonIstek = 0, zamanlayici;

    function ac() {
      if (acik) return;
      acik = true;
      kat.hidden = false;
      void kat.offsetWidth;                       // display:none → flex; geçişi tetikle
      document.body.classList.add('ara-open');
      girdi.focus();
      araBtn.setAttribute('aria-expanded', 'true');
    }
    function kapat() {
      if (!acik) return;
      acik = false;
      document.body.classList.remove('ara-open');
      araBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { if (!acik) kat.hidden = true; }, 380);
    }

    // suggest.json fiyatı TL string'i döner ("110.00") — kuruş DEĞİL, bölme yok.
    function paraBirimi(deger) {
      var n = Number(deger);
      if (!isFinite(n)) return '';
      return '₺' + n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function durumYaz(metin) { sonuc.innerHTML = '<p class="ara__durum">' + metin + '</p>'; }

    function ciz(urunler, q) {
      if (!urunler.length) { durumYaz(((window.ARTIST_I18N&&window.ARTIST_I18N.sonuc_yok)||"Sonuç bulunamadı")); return; }
      var html = urunler.map(function (u) {
        var img = (u.featured_image && u.featured_image.url)
          ? '<img class="ara__kart-gorsel" src="' + u.featured_image.url + '" alt="" loading="lazy" width="56" height="56">'
          : '<span class="ara__kart-gorsel"></span>';
        var fiyat = (u.price != null) ? '<span class="ara__kart-fiyat">' + paraBirimi(u.price) + '</span>' : '';
        return '<a class="ara__kart" href="' + u.url + '">' + img +
          '<span class="ara__kart-metin"><span class="ara__kart-ad">' + u.title + '</span>' + fiyat + '</span></a>';
      }).join('');
      sonuc.innerHTML = html +
        '<a class="ara__tumu" href="/search?q=' + encodeURIComponent(q) + '">' + ((window.ARTIST_I18N&&window.ARTIST_I18N.tum_sonuclar)||"Tüm sonuçlar →") + '</a>';
    }

    function ara(q) {
      var bu = ++sonIstek;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (veri) {
        if (bu !== sonIstek) return;               // eski istek geç döndü
        var p = (veri.resources && veri.resources.results && veri.resources.results.products) || [];
        ciz(p, q);
      }).catch(function () {
        if (bu !== sonIstek) return;
        durumYaz(((window.ARTIST_I18N&&window.ARTIST_I18N.arama_yok)||"Arama şu an kullanılamıyor"));
      });
    }

    girdi.addEventListener('input', function () {
      var q = girdi.value.trim();
      clearTimeout(zamanlayici);
      if (q.length < 2) { sonuc.innerHTML = ''; sonIstek++; return; }
      durumYaz(((window.ARTIST_I18N&&window.ARTIST_I18N.araniyor)||"Aranıyor…"));
      zamanlayici = setTimeout(function () { ara(q); }, 220);
    });
    girdi.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var q = girdi.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
    });
    araBtn.addEventListener('click', ac);
    kat.querySelector('.ara__kapat').addEventListener('click', kapat);
    kat.addEventListener('click', function (e) { if (e.target === kat) kapat(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && acik) kapat(); });
  })();

  var P = window.PRODUCT; if (!P) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var fmt = function (n) { return '₺' + Number(n).toLocaleString('tr-TR'); };
  var sel = {}, qty = 1;

  // tek varyantlı/Default seçenekleri gizle
  P.options = (P.options || []).filter(function (o) {
    return !(o.values.length === 1 && (/^(title|başlık)$/i.test(o.name) || /default title/i.test(o.values[0].v)));
  });

  function firstValFor(name) {
    var av = P.variants.find(function (x) { return x.available; }) || P.variants[0];
    if (av && av.opts && av.opts[name] != null) return av.opts[name];
    var o = P.options.find(function (x) { return x.name === name; });
    return o ? o.values[0].v : null;
  }
  function variant() {
    return P.variants.find(function (v) {
      return P.options.every(function (o) { return v.opts[o.name] === sel[o.name]; });
    });
  }
  function swatchImg() {
    var co = P.options.find(function (o) { return o.kind === 'swatch'; });
    if (co) { var vv = co.values.find(function (x) { return x.v === sel[co.name]; }); if (vv && vv.img) return vv.img; }
    return P.media && P.media[0];
  }
  function curImg() { var v = variant(); return (v && v.img) || swatchImg() || (P.media && P.media[0]); }
  function priceForVal(name, val) {
    var v = P.variants.find(function (x) {
      return x.opts[name] === val && P.options.every(function (o) { return o.name === name || x.opts[o.name] === sel[o.name]; });
    }) || P.variants.find(function (x) { return x.opts[name] === val; });
    return v ? v.price : null;
  }
  function valAvailable(name, val) {
    return P.variants.some(function (x) {
      return x.opts[name] === val && x.available && P.options.every(function (o) { return o.name === name || x.opts[o.name] === sel[o.name]; });
    });
  }

  function buildOptions() {
    var host = $('#optionGroups'); if (!host) return; host.innerHTML = '';
    P.options.forEach(function (o) {
      var wrap = document.createElement('div'); wrap.className = 'opt';
      wrap.innerHTML = '<div class="opt__head"><span class="opt__name">' + o.name + '</span><span class="opt__val" data-val="' + o.name + '"></span></div>';
      var box = document.createElement('div'); box.className = (o.kind === 'swatch') ? 'swatches' : 'pills';
      o.values.forEach(function (val) {
        var b = document.createElement('button'); b.type = 'button'; b.dataset.opt = o.name; b.dataset.value = val.v;
        if (o.kind === 'swatch') {
          b.className = 'swatch';
          if (val.hex) { b.style.background = val.hex; }
          else { var vi = (P.variants.find(function (x) { return x.opts[o.name] === val.v; }) || {}).img; if (vi) { b.style.backgroundImage = 'url(' + vi + ')'; b.style.backgroundSize = 'cover'; b.style.backgroundPosition = 'center'; } else { b.style.background = '#cfc7b8'; } }
          b.title = val.v; b.setAttribute('aria-label', val.v);
        }
        else { b.className = 'pill'; var pr = priceForVal(o.name, val.v); b.innerHTML = val.v + (pr != null && P.options.length > 1 ? '<small>' + fmt(pr) + '</small>' : ''); }
        b.addEventListener('click', function () { sel[o.name] = val.v; render(); });
        box.appendChild(b);
      });
      wrap.appendChild(box); host.appendChild(wrap);
    });
  }

  function render() {
    var v = variant();
    document.querySelectorAll('#optionGroups button').forEach(function (b) {
      b.classList.toggle('is-on', sel[b.dataset.opt] === b.dataset.value);
      b.setAttribute('aria-disabled', valAvailable(b.dataset.opt, b.dataset.value) ? 'false' : 'true');
    });
    document.querySelectorAll('.opt__val[data-val]').forEach(function (s) { s.textContent = sel[s.dataset.val] || ''; });
    setImage(curImg());
    var mt = document.querySelector('.gal__thumb[data-main] img'); if (mt) mt.src = curImg();
    document.querySelectorAll('.gal__thumb').forEach(function (x) { x.classList.toggle('is-on', x.hasAttribute('data-main')); });
    var pu = $('#priceUnit'); var pillO = P.options.find(function (o) { return o.kind === 'pill'; });
    if (pu) pu.textContent = pillO ? ('/ ' + sel[pillO.name]) : '';
    var sub = P.options.map(function (o) { return sel[o.name]; }).join(' · ');
    var ss = $('#stickySub'); if (ss) ss.textContent = sub;
    var si = $('#stickyImg'); if (si) si.src = curImg();
    var atc = $('#atc'), stock = $('#stock');
    if (v) {
      $('#priceNow').textContent = fmt(v.price);
      var aP = $('#atcPrice'); if (aP) aP.textContent = fmt(v.price * qty);
      var sp = $('#stickyPrice'); if (sp) sp.textContent = fmt(v.price);
      if (v.available) { atc.disabled = false; atc.querySelector('.atc__t').textContent = ((window.ARTIST_I18N&&window.ARTIST_I18N.sepete_ekle)||"Sepete ekle"); if (stock) stock.innerHTML = '<span class="dot"></span> ' + ((window.ARTIST_I18N&&window.ARTIST_I18N.stokta)||"Stokta var — hızlı kargo"); }
      else { atc.disabled = true; atc.querySelector('.atc__t').textContent = ((window.ARTIST_I18N&&window.ARTIST_I18N.tukendi)||"Tükendi"); if (stock) stock.innerHTML = '<span class="dot" style="background:var(--danger)"></span> ' + ((window.ARTIST_I18N&&window.ARTIST_I18N.secim_tukendi)||"Bu seçim tükendi"); }
    } else if (atc) { atc.disabled = true; atc.querySelector('.atc__t').textContent = ((window.ARTIST_I18N&&window.ARTIST_I18N.mevcut_degil)||"Mevcut değil"); if (stock) stock.textContent = ''; }
  }

  function setImage(src) {
    var stage = $('#galStage'); if (!stage || !src) return;
    var cur = stage.querySelector('.gal__img.is-on');
    if (cur && cur.dataset.src === src) return;
    var img = document.createElement('img');
    img.className = 'gal__img'; img.src = src; img.alt = P.title; img.dataset.src = src;
    stage.appendChild(img);
    void img.offsetWidth; img.classList.add('is-on');
    setTimeout(function () { if (cur && cur.parentNode) cur.parentNode.removeChild(cur); }, 500);
  }

  function bindQty() {
    var inp = $('#qty'); if (!inp) return;
    $('#qtyMinus').addEventListener('click', function () { qty = Math.max(1, qty - 1); inp.value = qty; render(); });
    $('#qtyPlus').addEventListener('click', function () { qty += 1; inp.value = qty; render(); });
    inp.addEventListener('change', function () { qty = Math.max(1, parseInt(inp.value) || 1); inp.value = qty; render(); });
  }
  function addToCart() {
    var v = variant(); if (!v || !v.available) return;
    if (P.demo || !v.id) { toast('Sepete eklendi (demo) — ' + P.options.map(function (o) { return sel[o.name]; }).join(' · ')); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function () { toast('Sepete eklendi'); refreshCart(); })
      .catch(function () { toast('Bir sorun oldu, tekrar dene'); });
  }
  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var el = $('#cartCount'); if (el) { el.textContent = c.item_count; el.style.display = c.item_count ? 'inline-flex' : 'none'; }
    }).catch(function () {});
  }
  var tT;
  function toast(m) { var t = $('#toast'); if (!t) return; $('#toastMsg').textContent = m; t.classList.add('is-on'); clearTimeout(tT); tT = setTimeout(function () { t.classList.remove('is-on'); }, 3600); }
  function bindAccordion() {
    document.querySelectorAll('.acc__q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.acc__item'), a = item.querySelector('.acc__a');
        var open = item.classList.toggle('is-open');
        a.style.maxHeight = open ? a.querySelector('.acc__a-in').scrollHeight + 'px' : 0;
      });
    });
  }
  function bindSticky() {
    var buy = $('#buyBox'), bar = $('#sticky'); if (!buy || !bar) return;
    new IntersectionObserver(function (e) { bar.classList.toggle('is-on', !e[0].isIntersecting); }, { rootMargin: '-130px 0px 0px 0px' }).observe(buy);
  }

  function init() {
    P.options.forEach(function (o) { sel[o.name] = firstValFor(o.name); });
    // URL'de ?variant=ID varsa o varyantı önceden seç (vitrin/derin-link)
    try {
      var vid = new URLSearchParams(location.search).get('variant');
      if (vid) {
        var hit = P.variants.find(function (x) { return String(x.id) === String(vid); });
        if (hit && hit.opts) P.options.forEach(function (o) { if (hit.opts[o.name] != null) sel[o.name] = hit.opts[o.name]; });
      }
    } catch (e) {}
    buildOptions(); bindQty(); bindAccordion(); bindSticky();
    var a = $('#atc'); if (a) a.addEventListener('click', addToCart);
    var sa = $('#stickyAtc'); if (sa) sa.addEventListener('click', addToCart);
    document.querySelectorAll('.gal__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.dataset.src || (t.querySelector('img') || {}).src;
        if (!src) return;
        setImage(src);
        document.querySelectorAll('.gal__thumb').forEach(function (x) { x.classList.toggle('is-on', x === t); });
      });
    });
    render(); if (!P.demo) refreshCart();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
